import './src/vaadin-select.js';
export * from './src/vaadin-select.js';
